import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'jquery.photoswipe/src/libs/photoswipe-ui-default';

var mainSwiper = new Swiper.default('.main-slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  autoplay: {
        delay: 5000,
  }

});

var swiper = new Swiper.default('.columns--first-slider .slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
});

var swiperReviews = new Swiper.default('.slider--reviews', {
  loop: true,
  slidesPerView: 3,
  navigation: {
    nextEl: '.swiper-button-next--reviews',
    prevEl: '.swiper-button-prev--reviews'
  },

  breakpoints: {

    1327: {
        slidesPerView: 2,
      },

      995: {
        slidesPerView: 1,
      }
    }
});

var swiperDecorations = new Swiper.default('.slider--decorations', {
  loop: true,
  slidesPerView: 3,
  navigation: {
    nextEl: '.swiper-button-next--decorations',
    prevEl: '.swiper-button-prev--decorations'
  },

  breakpoints: {

    1327: {
        slidesPerView: 2,
      },

      995: {
        slidesPerView: 1,
      }
    }
});

var innerSwiper = new Swiper.default('.inner-slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  autoplay: {
        delay: 3000,
  }

});


$(".top-products-slider").each(function(ind, val) {
  
  var countSlides = $(val).find(".swiper-slide").length;
  
  var productsSwiper = new Swiper.default(val, {
    loop: countSlides > 3,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next--top',
      prevEl: '.swiper-button-prev--top'
    },
    breakpoints: {

      1327: {
          slidesPerView: 2,
          loop: true
        },

        995: {
          slidesPerView: 1,
          loop: true
        }
      }
  });

  if(productsSwiper.loopedSlides == undefined) {
    var wrapper = $(".products-slider").find(".swiper-wrapper");
    var smallerWrapper = $(this).find(".swiper-wrapper");
    smallerWrapper.addClass('swiper-wrapper-small');
  }
});

$(".discount-products-slider").each(function(ind, val) {
  
  var countSlides = $(val).find(".swiper-slide").length;
  
  var discounSswiper = new Swiper.default(val, {
    loop: countSlides > 3,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next--discount',
      prevEl: '.swiper-button-prev--discount'
    },
    breakpoints: {

      1327: {
          slidesPerView: 2,
          loop: true
        },

        995: {
          slidesPerView: 1,
          loop: true
        }
      }
  });

  if(discounSswiper.loopedSlides == undefined) {
    var wrapper = $(".products-slider").find(".swiper-wrapper");
    var smallerWrapper = $(this).find(".swiper-wrapper");
    smallerWrapper.addClass('swiper-wrapper-small');
  }
});

$(".other-products-slider").each(function(ind, val) {
  var countSlides = $(val).find(".swiper-slide").length;
  
  var productsSwiper = new Swiper.default(val, {
    loop: countSlides > 3,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next--other',
      prevEl: '.swiper-button-prev--other'
    },
    breakpoints: {

      1327: {
          slidesPerView: 2,
          loop: true
        },

        995: {
          slidesPerView: 1,
          loop: true
        }
      }
  });

  if(productsSwiper.loopedSlides == undefined) {
    var wrapper = $(".products-slider").find(".swiper-wrapper");
    var smallerWrapper = $(this).find(".swiper-wrapper");
    smallerWrapper.addClass('swiper-wrapper-small');
  }
});

$(".similar-products-slider").each(function(ind, val) {
  var countSlides = $(val).find(".swiper-slide").length;
  
  var productsSwiper = new Swiper.default(val, {
    loop: countSlides > 3,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next--similar',
      prevEl: '.swiper-button-prev--similar'
    },
    breakpoints: {

      1327: {
          slidesPerView: 2,
          loop: true
        },

        995: {
          slidesPerView: 1,
          loop: true
        }
      }
  });

  if(productsSwiper.loopedSlides == undefined) {
    var wrapper = $(".products-slider").find(".swiper-wrapper");
    var smallerWrapper = $(this).find(".swiper-wrapper");
    smallerWrapper.addClass('swiper-wrapper-small');
  }
});

let priceSwiper = [];

$(".exemplary-pricing .slider").each(function(index, element) {
  $(element).addClass("slider-" + index).attr("data-gallery-index", index);
  
    priceSwiper.push(new Swiper.default(".slider-" + index, {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  }));

  // if(priceSwiper.loopedSlides == undefined) {
  //   var wrapper = $(".exemplary-pricing .slider").find(".swiper-wrapper");
  //   var smallerWrapper = $(this).find(".swiper-wrapper");
  //   smallerWrapper.addClass('swiper-wrapper-small');
  // }
});

var galleryThumbs = new Swiper.default('.inner-page .gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  breakpoints: {
    600: {
      slidesPerView: 5,
    },
    500: {
      slidesPerView: 4,
    },
    400: {
      slidesPerView: 3,
    },
  }
});

var galleryTop = new Swiper.default('.gallery-top', {
thumbs: {
  swiper: galleryThumbs
},
navigation: {
  nextEl: '.swiper-button-next--product',
  prevEl: '.swiper-button-prev--product'
},
});


let thumbSwipers = [];


$(".gallery .gallery-thumbs").each(function(index, element) {
  var $this = $(this);
  $(element).addClass("gallery-thumbs-" + index);

  thumbSwipers.push(new Swiper.default('.gallery-thumbs-' + index, { 
    slidesPerView: 3,
    spaceBetween: 30,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      400: {
        slidesPerView: 2,
      },
    }
  }));
});

let gallerySliders = [];

$(".slider--gallery").each(function(index, element) {
  var $this = $(this);
  $(element).addClass("slider--gallery-" + index).attr("data-gallery-index", index);
  var wrapper = $this.next('.arrows-wrapper');
  wrapper.find('.swiper-button-prev').addClass("btn-prev-" + index);
  wrapper.find(".swiper-button-next").addClass("btn-next-" + index);

  gallerySliders.push(new Swiper.default(".slider--gallery-" + index, { 
      loop: true,
      thumbs: {
        swiper: thumbSwipers[index]
      },
      slidesPerView: 5,
      spaceBetween: 20,
      navigation: {
        nextEl: '.btn-next-' + index,
        prevEl: '.btn-prev-' + index
      },
      breakpoints: {

        1360: {
            slidesPerView: 4,
            spaceBetween: 0
        },
    
        900: {
            slidesPerView: 3,
        },

        725: {
          slidesPerView: 2,
        },

        500: {
          slidesPerView: 1,
        }
      }
  }));
});

var initPhotoSwipeFromDOM = function(gallerySelector) {
  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function(el) {
    var thumbElements = el.childNodes,
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i]; // <figure> element

      // include only element nodes
      if (figureEl.nodeType !== 1) {
        continue;
      }

      linkEl = figureEl.children[0]; // <a> element

      size = linkEl.getAttribute("data-size").split("x");

      // create slide object
      item = {
        src: linkEl.getAttribute("href"),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };

      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // <img> thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute("src");
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function(el) {
      return el.tagName && el.tagName.toUpperCase() === "LI";
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;

    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }

      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split("&");
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split("=");
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function(
    index,
    galleryElement,
    disableAnimation,
    fromURL
  ) {
    var pswpElement = document.querySelectorAll(".pswp")[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)

    options = {
      /* "showHideOpacity" uncomment this If dimensions of your small thumbnail don't match dimensions of large image */
      //showHideOpacity:true,

      // Buttons/elements
      closeEl: true,
      captionEl: true,
      fullscreenEl: true,
      zoomEl: true,
      shareEl: true,
      counterEl: false,
      arrowEl: true,
      preloaderEl: true,
      bgOpacity: 0.8,
      tapToClose: true,
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute("data-pswp-uid"),

      getThumbBoundsFn: function(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = items[index].el.getElementsByTagName("img")[0], // find thumbnail
          pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    /* EXTRA CODE (NOT FROM THE CORE) - UPDATE SWIPER POSITION TO THE CURRENT ZOOM_IN IMAGE (BETTER UI) */

    // photoswipe event: Gallery unbinds events
    // (triggers before closing animation)
    gallery.listen("unbindEvents", function() {
      var galleryIndex = this.items[0].el.parentElement.parentElement.getAttribute('data-gallery-index');
      var slider = gallerySliders[galleryIndex];
     
      var pricingSlider = priceSwiper[galleryIndex];
      // This is index of current photoswipe slide
      var getCurrentIndex = gallery.getCurrentIndex();

      // Update position of the slider
      slider.slideTo(getCurrentIndex);
      if(priceSwiper.length) {
        pricingSlider.slideTo(getCurrentIndex);
      }
      
    });
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute("data-pswp-uid", i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

// execute above function
initPhotoSwipeFromDOM(".my-gallery");
initPhotoSwipeFromDOM(".exemplary-pricing .swiper-wrapper");
